import { useQuery } from "@tanstack/react-query"

import {
    AvailableFAQType,
    COMMON_GENERAL_CONFIG,
} from "@common-shared/config/general.config"

import { HttpHelper } from "../helpers/http.helper"

// refetch once in 1h by default
export function useFaqs<T>(
    faqType: AvailableFAQType,
    staleTime = 60 * 60 * 1000,
    apiBaseUrl = import.meta.env.VITE_API_URL,
): {
    faqs: T[]
    isLoading: boolean
} {
    const query = useQuery({
        staleTime,
        queryKey: [`useFaqs-${faqType}`],
        queryFn: async () => {
            // Check if apiBaseUrl has version set, if not add version to it
            if (!apiBaseUrl.match(/\/v\d+$/)) {
                apiBaseUrl += apiBaseUrl.endsWith("/")
                    ? COMMON_GENERAL_CONFIG.defaultApiVersion
                    : `/${COMMON_GENERAL_CONFIG.defaultApiVersion}`
            }

            const result = await HttpHelper.sendRequest(`${apiBaseUrl}/faqs`, {
                faqType,
            })

            return result || []
        },
    })

    return {
        isLoading: query.isLoading,
        faqs: (query.data || []) as T[],
    }
}
